import ApiService from '@/services/api.service';

const MedicationInboxService = {
    getAll(parameter) {
        var param = {};
        var _Url = '/MedicationInbox/';
        (param.SearchCriteria = parameter.SearchCriteria),
        (param.PageSize = parameter.PageSize),
        (param.PageNumber = parameter.PageNumber);

        param.DateFrom = parameter.DateFrom;
        param.DateTo = parameter.DateTo;
        param.Status = parameter.Status;
        param.ProgramCode = parameter.ProgramCode;
        param.PatientCode = parameter.PatientCode;
        param.BuildingCode = parameter.BuildingCode;
        param.LevelCode = parameter.LevelCode;
        param.RoomCode = parameter.RoomCode;
        param.PrescriberCode = parameter.PrescriberCode;
        param.RxStatus = parameter.RxStatus;
        param.IsInpatient = parameter.IsInpatient;
        param.BuildingRestriction = parameter.BuildingRestriction;
        param.ProgramsRestriction = parameter.ProgramsRestriction?.join(',') || '';

        if (parameter.NursingUnitCodes !== '') {
            if (_Url.includes('?')) {
                _Url += '&' + parameter.NursingUnitCodes;
            } else {
                _Url += '?' + parameter.NursingUnitCodes;
            }
        }

        const requestData = {
            method: 'get',
            url: _Url,
            params: param
        };
 
        return ApiService.customRequest(requestData);
    },

    SetStatus(recordIds) {
        return ApiService.post(`/MedicationInbox`, recordIds);
    }
};

export default MedicationInboxService;
